<template>
  <b-modal
    size="md"
    centered
    hide-footer
    :visible="showModal"
    no-close-on-esc
    no-close-on-backdrop
    @hide="hide"
    @hidden="hide"
    @change="(val) => $emit('update:show-modal', val)"
  >
    <div class="d-flex justify-content-center align-items-center flex-column">
      <h2 class="mb-3">{{ title }}</h2>
      <div class="w-100">
        <b-row class="w-100">
            <b-col cols="7">
              <h3 style="color: green;">Successful Imports:</h3>
            </b-col>

            <b-col cols="5" class="d-flex justify-content-end">
              <h3 style="color: green;" class="font-weight-bold">{{ importReport.successfulInserts || 0 }}</h3>
            </b-col>
        </b-row>

        <b-row class="w-100">
          <b-col cols="7">
            <h3 style="color: red">Failed Imports:</h3>
          </b-col>

          <b-col cols="5" class="d-flex justify-content-end">
            <h3 style="color: red" class="font-weight-bold">{{ importReport.failedInserts || 0 }}</h3>
          </b-col>
        </b-row>

        <b-row class="mb-2 w-100">
          <b-col cols="7">
            <h3 class="text-primary">Total Attempted:</h3>
          </b-col>
          <b-col cols="5" class="d-flex justify-content-end">
            <h3 class="font-weight-bold text-primary">{{ importReport.total || "N/A" }}</h3>
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-if="importReport && importReport.writeErrors && importReport.writeErrors.length">
      <b-table
        ref="refDataTable"
        class="position-relative"
        :items="importReport.writeErrors"
        :fields="tableColumns"
        responsive
        show-empty
        primary-key="id"
        empty-text="No matching records found"
        :tbody-tr-class="''"
      >
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import { BModal, BCardText, BRow, BCol, BTable } from "bootstrap-vue";

export default {
  name: "ImportReportModal",
  components: {
    BModal,
    BRow,
    BCol,
    BCardText,
    BTable
  },
  model: {
    prop: "showModal",
    event: "update:show-modal",
  },
  props: {
    showModal: {
      required: true,
      type: Boolean,
      default: false
    },
    title: {
      required: true,
      type: String,
      default: ""
    },
    importReport: {
        type: Object,
        required: true,
        default: () => ({})
    }
  },
  data() {
    return {
        tableColumns: [
            { key: "index", label: "# Row", formatter: (index) => index + 1 },
            { key: "code", label: "Code" },
            { key: "message", label: "Error Message" },
        ]
    };
  },
  methods: {
    hide() {
      this.$emit('update:show-modal', false);
    },
  },
};
</script>

<style scoped>
.font-md {
  font-size: 14px;
}
</style>
